import { XCircleIcon } from "@heroicons/react/24/outline";
import { Tooltip } from "flowbite-react";
import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";
import { useTextEditorContext } from "../../hooks/useTextEditorContext";
import { MARK_DELETION, MARK_INSERTION, getTrackChangesExtension } from "../extensions";
import { buttonStyle } from "./TextEditorMenuStyle";

export interface TextEditorMenuButtonTrackChangesRejectAllProps {
  className?: string;
  children?: React.ReactNode;
}

export const TextEditorMenuButtonTrackChangesRejectAll = ({
  className,
  children,
}: TextEditorMenuButtonTrackChangesRejectAllProps) => {
  const { t } = useTranslation("textEditor");
  const { editor, disabled } = useTextEditorContext();

  if (!editor) {
    return null;
  }

  const extension = getTrackChangesExtension(editor);
  if (
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    (!extension || !extension.options.enabled) &&
    !editor.isActive(MARK_DELETION) &&
    !editor.isActive(MARK_INSERTION)
  ) {
    return null;
  }

  return (
    <Tooltip content={t("buttons.rejectallchanges")}>
      <button
        type="button"
        onClick={() => {
          if (editor) {
            editor.chain().rejectAllChanges().focus().run();
          }
        }}
        className={twMerge(buttonStyle, className)}
        disabled={disabled}
      >
        {children ?? <XCircleIcon className="h-6 w-6" />}
      </button>
    </Tooltip>
  );
};
